module.exports = __webpack_public_path__ + "static/media/home-logo.7a9dd62d.png";